export default {
  name: 'ShStarRating',

  props: {
    value: {
      type: [Number, String],
      default: 3,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '1.5em',
    },
  },

  data() {
    return {
      ratingValue: this.value,
      tempRatingValue: null,
      ratings: [1, 2, 3, 4, 5],
    };
  },

  methods: {
    starOver(rating) {
      this.tempRatingValue = rating;
      this.ratingValue = rating;
    },
    starOut() {
      this.ratingValue = this.tempRatingValue;
    },
    setRating(rating) {
      this.tempRatingValue = rating;
      this.ratingValue = rating;
      this.$emit('setRating', rating);
    },
  },
};
